import React from 'react';
import AbstractView from '@src/components/_views/AbstractView';
import OrderProductForm from '@views/dashboard/production/OrderProductForm';
import ProductionDashboard from '@views/dashboard/ProductionDashboard';
import getUri from '@src/helpers/getUri';
import cacheableAccessor from '@src/helpers/cacheableAccessor';
import {EndpointUri} from '@src/@types/EndpointUri';

const getPageBreadcrumbs = cacheableAccessor(() => [
    {
        label: ProductionDashboard.pageTitle,
        uri: getUri('dashboards@production'),
    },
    {
        label: OrderProductPage.pageTitle,
        uri: {route: 'dashboards@production-order-product-page'} as EndpointUri,
    }
]);

export default class OrderProductPage extends AbstractView {
    static pageTitle = 'Dashboards:Production.order-product-page.page-title';

    protected renderContent() {
        return <OrderProductForm
                pageTitle={this.getPageTitle()}
                pageBreadcrumbs={this.getPageBreadcrumbs()}
        />;
    }

    protected getPageBreadcrumbs(): React.ComponentProps<typeof OrderProductForm>['pageBreadcrumbs'] {
        return getPageBreadcrumbs();
    }
}
